const videos = [
  {
  id: 1,
  thumbnail: "https://img.youtube.com/vi/a-b3ym5ghPk/hqdefault.jpg",
  url: "https://youtu.be/a-b3ym5ghPk?si=pJ_jGApKrE6lvGwn",
},
  {
    id: 2,
    thumbnail: "https://img.youtube.com/vi/DCk7PicaKPw/hqdefault.jpg",
    url: "https://youtu.be/DCk7PicaKPw?si=mjH_Pnq8l_PvbPHN",
  },

  {
    id: 3,
    thumbnail: "https://img.youtube.com/vi/exJTpTqm1fI/hqdefault.jpg",
    url: "https://youtu.be/exJTpTqm1fI?si=jQtxaROLlfvkXBf6",
  },
  {
    id: 4,
    thumbnail: "https://img.youtube.com/vi/1vVW4KlSWjU/hqdefault.jpg",
    url: "https://youtu.be/1vVW4KlSWjU?si=OkSemopq40TAPakO",
  },
  {
    id: 5,
    thumbnail: "https://img.youtube.com/vi/92SrYqVTc4A/hqdefault.jpg",
    url: "https://youtu.be/92SrYqVTc4A?si=t4Sg5iYPQldN5iM_",
  },
  {
    id: 6,
    thumbnail: "https://img.youtube.com/vi/D7foiFZ-EcA/hqdefault.jpg",
    url: "https://youtu.be/D7foiFZ-EcA?si=J5jVcCAkEtBj2s9o",
  },
];

export default videos;
